import { useNuxtApp } from '#imports'
import { getAppContext, getConfig } from '@b2ag/micro-front-tools'

export async function initHubspot() {
  if (window.location.hostname.includes('localhost')) return

  const nuxtApp = useNuxtApp()
  const { appFrontType } = getAppContext()

  if (appFrontType === 'agri') {
    if (!getConfig('HUBSPOT_PORTAL_ID')) return

    const HubspotPlugin = await import('@b2ag/plugin-hubspot').then((m) => m.default || m)

    nuxtApp.vueApp.use(HubspotPlugin, {
      portalId: getConfig('HUBSPOT_PORTAL_ID'),
    })
  }
}
